import { CreditReportEffects } from './credit-report.effects';

export const effects: any[] = [CreditReportEffects];

export * from './credit-report.effects';
